import { createSelector, lruMemoize } from 'reselect'
import { RootState }                  from '../../../store'
import { shallowEqual }               from 'react-redux'

const getIncludeTransient = (state: RootState) => state.map.includeTransient

const getWaterSystemCoordinatesData = (state: RootState) => state.waterSystemCoordinates.data

const getWaterSystemCoordinates = (state: RootState) => state.waterSystemCoordinates.data.items || []
const getInvalidIdx = (state: RootState) => state.waterSystemCoordinates.data.invalidIdx
const getBoundingBox = (state: RootState) => state.waterSystemCoordinates.data.boundingBox

const error = (state: RootState) => state.waterSystemCoordinates.error
const loading = (state: RootState) => state.waterSystemCoordinates.loading
const success = (state: RootState) => state.waterSystemCoordinates.success

const makeSortedCoordinates = createSelector(
  [
    getWaterSystemCoordinates,
    (state: RootState, sortOrder: string) => sortOrder
  ],
  (coordinates, sortOrder: string) => {
    if (!coordinates) return []

    return [...coordinates].sort((a, b) => {
      const aPopulationServed = a.POPULATION_SERVED_COUNT || 0
      const bPopulationServed = b.POPULATION_SERVED_COUNT || 0

      return sortOrder === 'highest'
        ? bPopulationServed - aPopulationServed
        : aPopulationServed - bPopulationServed
    })
  },
  {
    memoize: lruMemoize,
    memoizeOptions: {
      equalityCheck: shallowEqual,
      resultEqualityCheck: shallowEqual,
      maxSize: 10,
    },
    argsMemoize: lruMemoize,
    argsMemoizeOptions: {
      equalityCheck: shallowEqual,
      resultEqualityCheck: shallowEqual,
      maxSize: 10,
    },
  },
)

const makeFilteredCoordinates = createSelector(
  [getWaterSystemCoordinates, getIncludeTransient],
  (coordinates, includeTransient) => {
    if (!coordinates) return []
    if (includeTransient) return coordinates
    return coordinates.filter(c => c.PWS_TYPE_CODE !== 'TNCWS')
  }
)

export const WaterSystemCoordinatesSelector = {
  getWaterSystemCoordinatesData,
  getWaterSystemCoordinates,
  getInvalidIdx,
  getBoundingBox,
  error,
  loading,
  success,
  makeSortedCoordinates,
  makeFilteredCoordinates,
}
